import React from 'react';
import PlayerTiles from './PlayerTiles';
import Board from './Board';
import DragLayer from './DragLayer';

import colors from '../colors';

const Layout = props => {
  return (
    <div style={{ display: 'flex' }}>
      <DragLayer />
      <Board {...props} />
      <PlayerTiles {...props} />
      <p>
        <stong>It is {colors[props.ctx.currentPlayer]}'s turn</stong>
      </p>
    </div>
  );
};

export default Layout;
